import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TeamRoleState = {
  roles: [],
  matrix: null,
}

export const TeamRoleActions = {

  createTeamRole: async (_, { teamId, role }) => {
    return axiosRequest.
      post(`/teams/${teamId}/roles`, role).
      then(({ data }) => data).
      catch(handleError)
  },

  updateRole: async (_, { teamId, role }) => {
    return axiosRequest.
      put(`/teams/${teamId}/roles/${role.id}`, role).
      then(({ data }) => data).
      catch(handleError)
  },

  getTeamRole: async (_, { teamId, roleId }) => {
    return axiosRequest.
      get(`/teams/${teamId}/roles/${roleId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  getTeamRoles: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/roles`).
      then(({ data }) => {
        commit('setTeamRoles', data)
        return data
      }).
      catch(handleError)
  },

  getTeamRolesMatrix: async ({ commit }, teamId) => {
    return axiosRequest.
      get(`/teams/${teamId}/roles/matrix`).
      then(({ data }) => {
        commit('setTeamRolesMatrix', data)
        return data
      }).
      catch(handleError)
  },

  togglePermissionForRole: async (_, { teamId, roleId, identifier }) => {
    return axiosRequest.
      patch(`/teams/${teamId}/roles/${roleId}/toggle_permission`, { identifier }).
      then(({ data }) => data).
      catch(handleError)
  },

  updateMemberRole: async (_, { teamId, memberId, roleId }) => {
    return axiosRequest.
      put(`/teams/${teamId}/members/${memberId}`, { role_id: roleId }).
      then(({ data }) => data).
      catch(handleError)
  },

  addTeamMember: async (_, { teamId, userId, roleId }) => {
    return axiosRequest.
      post(`/teams/${teamId}/members`, { user_id: userId, role_id: roleId, team_id: teamId }).
      then(({ data }) => data).
      catch(handleError)
  },

  removeMember: async (_, { teamId, userId }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/members/${userId}`).
      then(({ data }) => data).
      catch(handleError)
  },

  removeRole: async (_, { teamId, roleId }) => {
    return axiosRequest.
      delete(`/teams/${teamId}/roles/${roleId}`).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const TeamRoleGetters = {
  teamRoles: state => state.roles || [],
  teamRolesMatrix: state => state.matrix,
}

export const TeamRoleMutations = {
  setTeamRoles: (state, roles) => (state.roles = roles),
  setTeamRolesMatrix: (state, matrix) => (state.matrix = matrix),
}
